import {
  Button,
  FormControl,
  FormLabel,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { setIn, useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import {
  formGroupContainer,
  groupStyled,
  header,
  labelStyled,
  row,
} from "../../components/300/styles";
import { StyledForm } from "../../components/300/UiComponent";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import CustomizedSnackbars from "../300/curriculum/CustomizedSnackbars";

export const validationSchema = yup.object({
  type: yup.string("Enter Status Title").required("Position title is required"),
  max_load: yup
    .number("Enter maximum load ")
    .required("This field is required"),
  expected_load: yup
    .number("Enter expected load ")
    .required("This field is required"),
});

function EditStatus() {
  const api = useAxiosPrivate();
  let location = useLocation();
  let navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [adding, setAdding] = useState(false);
  let [initialValues, setInitialValues] = useState({
    id: location.state[0],
    type: location.state[1],
    max_load: location.state[2],
    expected_load: location.state[3],
  });
  // useEffect(() => {
  //   api
  //     .get("staffStatus/getStatus/", {params: {id: location.state.id}})
  //     .then((res) => {
  //       setInitialValues(
  //         {
  //           type: res.data.type,
  //           max_load: res.data.max_load,
  //           expected_load: res.data.expected_load
  //         }
  //       )
  //       console.log(res.data);
  //     })
  //     .catch((err) => console.log(err));
  // }, []);

  //for snackbar
  // const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [message, setMessage] = useState({
    message: "",
    type: "",
  });
  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      let newValues = { ...values };
      // alert(JSON.stringify(newValues, null, 2));
      setAdding(true);
      api
        .get("/staffStatus/editStatus/", { params: { newValues } })
        .then((res) => {
          setAdding(false);
          navigate("/system_setting/status");
        })
        .catch((err) => {
          setAdding(false);
          // setSnackBarOpen(true);
          console.log(err);
          setMessage({ message: err.response.data.message, type: "error" });
        });
    },
  });

  return (
    <StyledForm onSubmit={formik.handleSubmit}>
      <Box sx={header}>
        <Typography
          variant="span"
          sx={{
            fontSize: "1.14rem",
            fontWeight: "600",
            lineHeight: "23.2px",
            color: "primary.main",
          }}>
          Status Registration
        </Typography>
        {/* <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            setOpen(true);
          }}>
          Import
        </Button> */}
      </Box>
      <Box sx={formGroupContainer}>
        <Box sx={{ ...row, padding: "40px 0px" }}>
          <FormControl sx={groupStyled}>
            <FormLabel htmlFor="type" sx={labelStyled}>
              Status Type
            </FormLabel>
            <TextField
              id="type"
              name="type"
              value={formik.values.type}
              onChange={(e) => {
                // setSnackBarOpen(false);
                formik.handleChange(e);
              }}
              error={formik.errors.type && Boolean(formik.errors.type)}
              helperText={formik.touched.type && formik.errors.type}
              fullWidth
            />
          </FormControl>

          <FormControl sx={groupStyled}>
            <FormLabel htmlFor="max_load" sx={labelStyled}>
              Maximum Load
            </FormLabel>
            <TextField
              id="max_load"
              name="max_load"
              onChange={formik.handleChange}
              error={formik.touched.max_load && Boolean(formik.errors.max_load)}
              type="number"
              value={formik.values.max_load}
              helperText={formik.touched.max_load && formik.errors.max_load}
            />
          </FormControl>
          <FormControl sx={groupStyled}>
            <FormLabel htmlFor="expected_load" sx={labelStyled}>
              Expected Load
            </FormLabel>
            <TextField
              id="expected_load"
              name="expected_load"
              onChange={formik.handleChange}
              error={
                formik.touched.expected_load &&
                Boolean(formik.errors.expected_load)
              }
              type="number"
              value={formik.values.expected_load}
              helperText={
                formik.touched.expected_load && formik.errors.expected_load
              }
            />
          </FormControl>
        </Box>
      </Box>
      {/* {snackBarOpen && (
        <CustomizedSnackbars {...{ setSnackBarOpen, snackBarOpen, message }} />
      )} */}

      <Box
        sx={{
          display: "flex",
          gap: "1.8rem",
          justifyContent: "flex-end",
          width: "100%",
        }}>
        <NavLink
          to={"/system_setting/status"}
          style={{ textDecoration: "none" }}>
          <Button variant="outlined" color="third">
            Cancel
          </Button>
        </NavLink>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "secondary.main",
            "&:hover": {
              backgroundColor: "secondary.hover",
            },
          }}
          type="submit">
          Register
        </Button>
      </Box>
    </StyledForm>
  );
}

export default EditStatus;
